import React, { useState, useEffect } from 'react';

const ApplicationDetailsForm = ({ initialData = {}, onNext, onBack }) => {
  const [coverLetter, setCoverLetter] = useState(initialData.cover_letter || '');
  const [relocation, setRelocation] = useState(initialData.relocation ?? '');

  useEffect(() => {
    setCoverLetter(initialData.cover_letter || '');
    setRelocation(initialData.relocation ?? '');
  }, [initialData]);

  const handleNext = () => {
    onNext({
      cover_letter: coverLetter || null,
      relocation: relocation || null,
    });
  };

  return (
    <div className="card-style-1">
      <div className="mb-30">
        <label className="form-label">Write a cover letter (optional)</label>
        <textarea
          className="form-control"
          rows={4}
          maxLength={2000}
          value={coverLetter}
          onChange={(e) => setCoverLetter(e.target.value)}
          placeholder="Introduce yourself, highlight relevant experience, and explain your interest."
          style={{ resize: 'vertical', minHeight: 90, maxHeight: 220 }}
        />
      </div>

      <div className="mb-30">
        <label className="form-label">
          Would you be able to relocate to be within reasonable commuting distance from job address?
        </label>
        <div className="d-flex mt-10" style={{ flexDirection: 'column', rowGap: 6 }}>
          <label className="radio-container" style={{ display: 'flex', alignItems: 'center', gap: 8, margin: 0, lineHeight: 1.2, fontSize: 14 }}>
            <input
              type="radio"
              name="relocation"
              checked={relocation === 'yes'}
              onChange={() => setRelocation('yes')}
              style={{ width: 16, height: 16, margin: 0 }}
            />
            <span className="text-small" style={{ lineHeight: 1.2 }}>Yes</span>
          </label>
          <label className="radio-container" style={{ display: 'flex', alignItems: 'center', gap: 8, margin: 0, lineHeight: 1.2, fontSize: 14 }}>
            <input
              type="radio"
              name="relocation"
              checked={relocation === 'no'}
              onChange={() => setRelocation('no')}
              style={{ width: 16, height: 16, margin: 0 }}
            />
            <span className="text-small" style={{ lineHeight: 1.2 }}>No</span>
          </label>
          <label className="radio-container" style={{ display: 'flex', alignItems: 'center', gap: 8, margin: 0, lineHeight: 1.2, fontSize: 14 }}>
            <input
              type="radio"
              name="relocation"
              checked={relocation === 'na'}
              onChange={() => setRelocation('na')}
              style={{ width: 16, height: 16, margin: 0 }}
            />
            <span className="text-small" style={{ lineHeight: 1.2 }}>Not applicable</span>
          </label>
        </div>
      </div>

      <div className="d-flex justify-content-between">
        <button type="button" className="btn btn-border" onClick={onBack}>
          Back
        </button>
        <button type="button" className="btn btn-default" onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  );
};

export default ApplicationDetailsForm;


